/* External dependencies */
import { gql } from '@apollo/client';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import { Device, CreateDeviceInput } from '../../types';

const CREATE_DEVICE = gql`
  mutation CreateDevice($input: T26CreateDeviceInput!) {
    T26CreateDevice(input: $input) {
      id
      address
      paymentService
      deviceLocation {
        lat
        lon
      }
      isVerified
      registrationDate
      comment
      user {
        id
      }
    }
  }
`;

export const createDeviceRequest = async (createDeviceInput: CreateDeviceInput): Promise<Device> => {
  try {
    const client = await setAuthenticatedClient();

    console.log('Sending create device request with input:', createDeviceInput);

    const response = await client.mutate({
      mutation: CREATE_DEVICE,
      variables: { input: createDeviceInput },
    });

    console.log('Create device response:', response.data);

    return response.data.T26CreateDevice;
  } catch (error) {
    console.error('Error creating device:', error);
    throw error;
  }
};
